import {onError} from '@apollo/client/link/error';

import {redirectIfSessionReplaced} from 'lib/sessionReplaced';

/**
 * Apollo link that sends the user to the expired-session page when a GraphQL response says
 * the session was replaced, the same rule REST requests follow in `App.react.js`.
 */
export const sessionReplacedLink = onError(({networkError}) => {
  if (networkError && 'response' in networkError) {
    redirectIfSessionReplaced(networkError.response?.headers?.get('x-authorization-inactive'));
  }
});
